<div [ngClass]="['flow-badge', 'size-' + size.toLowerCase(), 'color-' + getBadgeColor()]" [ngStyle]="{ border: '1px solid ' + getBorderColor(), 'background-color': getBackgroundColor() }">
  <img [src]="icon" *ngIf="type === 'Default'" class="icon" />
  <div class="status" [ngClass]="['color-' + color.toLowerCase()]" *ngIf="type === 'Status'"></div>
  <span class="h5-semibold" style="font-size: 12px" [ngStyle]="{ color: getTextColor() }">{{ text }}</span>
</div>
